
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"238","height":"337","viewBox":"0 0 238 337","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#D2232A","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M35.74 66.404l16.407 21.18-16.406 21.251-16.764-21.25z"}}),_c('text',{attrs:{"font-family":"Roboto-Bold, Roboto","font-size":"59","font-weight":"bold","transform":"translate(13.5 2.404)"}},[_c('tspan',{attrs:{"x":"5.575","y":"55"}},[_v('2')])]),_c('path',{attrs:{"d":"M202.264 270.404l-16.407-21.18 16.407-21.25 16.763 21.25z"}}),_c('text',{attrs:{"font-family":"Roboto-Bold, Roboto","font-size":"59","font-weight":"bold","transform":"rotate(180 112.252 167.202)"}},[_c('tspan',{attrs:{"x":"5.575","y":"55"}},[_v('2')])]),_c('g',[_c('path',{attrs:{"d":"M119.619 58.404l10.906 15.974-10.906 16.026-11.144-16.026zM119.381 278.404l-10.906-15.973 10.906-16.027 11.144 16.027z"}})])])])
          )
        }
      }
    